// QrScanner.js
import React, { useState } from 'react';
import { QrReader } from 'react-qr-reader';

const QrScanner = ({ onScanResult, isScanning, setIsScanning }) => {
  const [facingMode, setFacingMode] = useState('environment'); // orqa kamera default

  const handleScanResult = (result, error) => {
    if (result) {
      onScanResult(result?.text);
      setIsScanning(false);
    }
    if (error) {
      console.error('❌ QR error:', error);
    }
  };

  const handleClose = () => {
    setIsScanning(false);
  };

  const toggleCamera = () => {
    setFacingMode(prev =>
      prev === 'environment' ? 'user' : 'environment'
    );
  };

  return (
    <>
      {isScanning && (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="relative w-[80%] max-w-[600px] aspect-square bg-black rounded-lg overflow-hidden">
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="absolute top-2 right-2 text-white text-xl bg-red-600 hover:bg-red-700 rounded-full px-3 py-1 z-50"
            >
              ✕
            </button>

            {/* Camera Toggle Button */}
            <button
              onClick={toggleCamera}
              className="absolute top-2 left-2 text-white text-sm bg-gray-800 hover:bg-gray-700 rounded px-2 py-1 z-50"
            >
              Switch Camera
            </button>

            {/* QR Reader */}
            {facingMode === 'environment' && (
              <QrReader
                key="env"
                constraints={{ facingMode: 'environment' }}
                onResult={handleScanResult}
                containerStyle={{ width: '100%', height: '100%' }}
                videoStyle={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            )}

            {facingMode === 'user' && (
              <QrReader
                key="user"
                constraints={{ facingMode: 'user' }}
                onResult={handleScanResult}
                containerStyle={{ width: '100%', height: '100%' }}
                videoStyle={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default QrScanner;
